<script setup lang="ts">
const prefix = 'components.home.ekomiNotation';
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-2 sm:flex-row md:justify-start">
    <div
      class="flex gap-1"
      aria-hidden="true"
    >
      <UiCustomStar
        v-for="index in 4"
        :key="index"
      />
      <UiCustomStar :fill="0.75" />
    </div>

    <span class="text-center text-sm font-medium text-text-inverse sm:text-left">
      {{ $t(`${prefix}.note`) }}
      <span class="text-text-inverse/80">{{ $t(`${prefix}.reviews`) }}</span>
    </span>
  </div>
</template>
